export default ({ request }) => ({
  ecomOrderPlatformAccountListApi(data = {}) {
    return request({
      url: '/ecomorder/platform/account/list',
      method: 'post',
      data,
    })
  },
  ecomOrderPlatformAccountDetailApi(data = {}) {
    return request({
      url: '/ecomorder/platform/account/detail',
      method: 'post',
      data,
    })
  },
  ecomOrderPlatformAccountSaveApi(data = {}) {
    return request({
      url: '/ecomorder/platform/account/save',
      method: 'post',
      data,
    })
  },
  ecomOrderPlatformAccountDnabledApi(data = {}) {
    return request({
      url: '/ecomorder/platform/account/enabled',
      method: 'post',
      data,
    })
  },
  ecomOrderPlatformAccountDisabledApi(data = {}) {
    return request({
      url: '/ecomorder/platform/account/disabled',
      method: 'post',
      data,
    })
  },
  ecomOrderPlatformAccountDelApi(data = {}) {
    return request({
      url: '/ecomorder/platform/account/del',
      method: 'post',
      data,
    })
  },
  ecomOrderPlatformAccountSubsEventListApi(data = {}) {
    return request({
      url: '/ecomorder/ecom/platform/account/subs/event/list',
      method: 'post',
      data,
    })
  },
  ecomOrderPlatformAccountSubsEventSaveApi(data = {}) {
    return request({
      url: '/ecomorder/ecom/platform/account/subs/event/save',
      method: 'post',
      data,
    })
  },
  ecomOrderPlatformAccountSubsEventDelApi(data = {}) {
    return request({
      url: '/ecomorder/ecom/platform/account/subs/event/del',
      method: 'post',
      data,
    })
  },
  ecomOrderPlatformSubsEventListApi(data = {}) {
    return request({
      url: '/ecomorder/ecom/platform/subs/event/list',
      method: 'post',
      data,
    })
  },
  ecomOrderPlatformSubsEventSaveApi(data = {}) {
    return request({
      url: '/ecomorder/ecom/platform/subs/event/save',
      method: 'post',
      data,
    })
  },
  ecomOrderPlatformSubsEventDelApi(data = {}) {
    return request({
      url: '/ecomorder/ecom/platform/subs/event/del',
      method: 'post',
      data,
    })
  },
})
